module.exports = __webpack_public_path__ + "img/sound.79bbd6ce.png";